import React from 'react';

import { IconProps } from './types';

export const ShieldIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 250 250"
    ref={forwardedRef}
    {...props}
  >
    <path
      d="M224.7,42.4c-0.4-3-2.5-5.4-5.4-6.2L127,10.5c-1.3-0.4-2.7-0.4-4,0L30.8,36.2c-2.9,0.8-5,3.2-5.4,6.2
	c-0.5,3.8-12.7,94.7,18.6,140c31.3,45.2,77.4,56.7,79.3,57.2c0.6,0.1,1.2,0.2,1.8,0.2s1.2-0.1,1.8-0.2c1.9-0.5,48.1-12,79.3-57.2
	C237.4,137.1,225.2,46.2,224.7,42.4z M192.6,173c-27.1,39.2-67.7,49-67.7,49v-97H41.2c-4.9-36.4,0.3-73.8,0.3-73.8L124.9,28v97h83.7
	C206.2,142.7,201.5,160.2,192.6,173z"
    />
  </svg>
));
ShieldIcon.displayName = 'ShieldIcon';

export default ShieldIcon;
